/** Update configured tenant branding on SPA navigation, including public SSO routes. */
export const syncDocumentFavicon = (
  documentRef: Document,
  faviconUrl: string | undefined
): void => {
  const href = faviconUrl || '/favicon.ico';
  const type = faviconUrl ? 'image/png' : 'image/x-icon';
  let icon = documentRef.querySelector<HTMLLinkElement>('link[rel~="icon"]');

  if (!icon) {
    icon = documentRef.createElement('link');
    icon.rel = 'icon';
    documentRef.head.appendChild(icon);
  }

  if (icon.getAttribute('type') !== type) icon.type = type;
  if (icon.getAttribute('href') !== href) icon.setAttribute('href', href);
};
